/**
 * Catalog of all SalesGod features for the cockpit dashboard.
 * Each feature: title, short benefit, settings tab, tier (essential|extra), optional plan requirement, optional Academy category for video link.
 * academyCategoryId: Firebase key from Academy/categories – when set, "Watch video" links to /academy/:categoryId
 */

export const FEATURE_CATALOG = [
  {
    id: 'emailAccount',
    title: 'Email accounts',
    description: 'Connect your email inboxes (IMAP/SMTP). SalesGod sends and replies through them – with your sender identity.',
    tab: 'email',
    icon: 'fa fa-envelope',
    tier: 'essential',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'footer',
    title: 'Email footer',
    description: 'Consistent footer for all outgoing emails: text, image, social links. Important for recognition and legal details.',
    tab: 'emailPreferences',
    icon: 'fa fa-align-left',
    tier: 'essential',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'topics',
    title: 'Email templates',
    description: 'Templates for different use cases – e.g. first touch, follow-up. The AI uses them as a base and adapts them per lead.',
    tab: 'topics',
    icon: 'fa fa-file-alt',
    tier: 'essential',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'warmup',
    title: 'Warmup Engine',
    description: 'New email addresses are gradually warmed up for sending. Improves deliverability and protects your reputation.',
    tab: 'trueWarmup',
    icon: 'fa fa-fire',
    tier: 'essential',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'safeGuard',
    title: 'SafeGuard',
    description: 'Checks emails before send for risks (e.g. too aggressive, compliance). You decide which emails go out.',
    tab: 'safeGuard',
    icon: 'fa fa-shield-alt',
    tier: 'essential',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'leadFlows',
    title: 'Lead Flows',
    description: 'Automated flows for leads: e.g. send follow-up after X days or change status. Saves time and adds structure.',
    tab: 'leadSettings',
    icon: 'fa fa-project-diagram',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'agents',
    title: 'Inbox Reply',
    description: 'Define the cases that land in your inbox and let each one be answered and tagged by content. Stay in control without reading every email manually.',
    tab: 'agents',
    icon: 'fa fa-brain',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'blacklist',
    title: 'BlackList',
    description: 'Domains or addresses that must not be contacted. Prevents wrong sends and protects from legal issues.',
    tab: 'blacklist',
    icon: 'fa fa-ban',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'research',
    title: 'Research',
    description: 'Extra intel on leads: emails, socials, decision makers. Helps you write more personalized, targeted messages.',
    tab: 'research',
    icon: 'fa fa-search',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'integrations',
    title: 'API & Integrations',
    description: 'API, Calendly, Custom Fields. Connect SalesGod to your CRM or calendar for seamless workflows.',
    tab: 'api',
    icon: 'fa fa-plug',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'customFields',
    title: 'Custom Fields',
    description: 'Your own fields for leads – e.g. industry, budget. Use them in templates and flows for more personalization.',
    tab: 'customFields',
    icon: 'fa fa-tags',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'extraSettings',
    title: 'Calendly & extras',
    description: 'Add booking links (e.g. Calendly) to emails. Let prospects book meetings directly.',
    tab: 'extraSettings',
    icon: 'fa fa-calendar-check',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'whatsapp',
    title: 'WhatsApp',
    description: 'Send WhatsApp messages from SalesGod. For users who prefer to be reached via chat.',
    tab: 'whatsapp',
    icon: 'fa fa-whatsapp',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
  {
    id: 'team',
    title: 'Team',
    description: 'Invite team members and set permissions. Let multiple people work on one account.',
    tab: 'team',
    icon: 'fa fa-users',
    tier: 'extra',
    planRequired: null,
    academyCategoryId: null,
  },
];
